/* Core & libraries */
import React, { useEffect, useState } from 'react';
import { useTheme } from "react-jss";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useReportsService } from "../../../../../services/reportsService";

/* Components */
import { ReactComponent as DownloadIcon } from "../../../../../resources/images/download-02.svg";
import SelectBookingDates from "../../../../selectBookingDates";
import UCButton from "../../../../buttons";

/* Styles */
import styles from "./styles.js"
import { AIRLINES } from '../../../../../constants/appConstants';
import UCSelect from '../../../../ucselect';
import { customSelectStyles } from '../../bookingsTab/bookingFilters/styles';
import { useUserContext } from '../../../../../contexts/userContext';

const messages = defineMessages({
  yearToDateLabel: {
    id: "bookings.filters.yearToDate"
  },
  downloadFlightSegmentsCSV: {
    id: "receipts.button"
  }
})

const FlightSegmentsFilters = ({ gridOptions, setGridOptions, enableDownloadButton }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const intl = useIntl();

  const { downloadFlightSegments, getSuppliersByCompany } = useReportsService();
  const [showBookingOverlay, setShowBookingOverlay] = useState(false);
  const [showTravelOverlay, setShowTravelOverlay] = useState(false);
  const [airlineOptions, setAirlineOptions] = useState([]);

  const handleDownload = () => {
    downloadFlightSegments({ ...gridOptions });
  }
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  useEffect(() => {
    const fetchSuppliers = async () => {
      const data = await getSuppliersByCompany();
      if (data?.suppliers) {
        const allAirlinesOption = {
          value: '',
          label: <FormattedMessage id="reports.provider.all" />,
        };
        const supplierOptions = data.suppliers.map((s) => ({
          value: s.providerEntityID,
          label: <FormattedMessage id={`reports.provider.${s.providerCode}`} />,
        }));
        setAirlineOptions([allAirlinesOption, ...supplierOptions]);
      }
    };
    fetchSuppliers();
  }, []);

  return (
    <div className={classes.filters}>
      <div className={classes.filterButtons}>
        {providerCode === AIRLINES.UC && (
          <div className={classes.filterText}>
            <p>
              <FormattedMessage id="reports.airline.label" />
            </p>
            <UCSelect
              className={classes.airlines}
              styles={customSelectStyles}
              displayName={<FormattedMessage id="reports.provider.all" />}
              options={airlineOptions}
              defaultValue={{
                value: '',
                label: <FormattedMessage id="reports.provider.all" />,
              }}
              onChange={(item) =>
                setGridOptions({
                  ...gridOptions,
                  page: 1,
                  providerEntityId: item.value,
                })
              }
            />
          </div>
        )}
        <div className={classes.filterDates}>
            <div className={classes.filterText}>
              <p>
                <FormattedMessage id="bookings.filters.bookingDate" />
              </p>
              <SelectBookingDates
                gridOptions={gridOptions}
                setGridOptions={setGridOptions}
                defaultText={intl.formatMessage(messages.yearToDateLabel)}
                defaultValue="yearToDate"
                id={'booking'}
                showOverlay={showBookingOverlay}
                setShowOverlay={setShowBookingOverlay}
              />
            </div>
          <div className={classes.filterText}>
            <p>
              <FormattedMessage id="bookings.filters.travelDate" />
            </p>
            <SelectBookingDates
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              defaultText={intl.formatMessage(messages.yearToDateLabel)}
              defaultValue={'yearToDate'}
              id={'travel'}
              showOverlay={showTravelOverlay}
              setShowOverlay={setShowTravelOverlay}
            />
          </div>
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <UCButton
          type="primary"
          className={classes.button}
          onClick={handleDownload}
          text={<FormattedMessage id="receipts.button" />}
          ariaLabel={intl.formatMessage(messages.downloadFlightSegmentsCSV)}
          tabIndex={0}
          icon={<DownloadIcon />}
          disabled={!enableDownloadButton}
          spinner={{
            name: 'downloadFlightSegmentsSpinner',
            size: 20,
          }}
        />
      </div>
    </div>
  );
}

export default FlightSegmentsFilters;
